export const labelText = 'text-cosmicCyan text-xs xl:text-sm font-normal';
export const placeholderBox =
	'bg-[#1B0D2A] focus:bg-[#1B0D2A] border-cosmicMagenta400 rounded w-full font-regular ml-0 pl-1 -mx-3 flex-grow -pt-1 pb-1 md:py-2 text-gray-100';
export const placeholderBoxComponent =
	'bg-[#1B0D2A] focus:bg-[#1B0D2A] border-cosmicMagenta400 rounded w-full font-regular ml-0 pl-1 -mx-3 text-gray-100';
export const textFieldParticipants = 'text-lg lg:text-xl 3xl:text-2xl text-gray-100';
export const textField = 'text-md lg:text-lg text-gray-100';
export const textFieldTitle =
	'font-normal text-2xl xl:text-3xl 2xl:text-4xl align-middle text-left py-auto px-auto text-gray-100';
export const inputDiv = 'flex border-none rounded w-full font-light text-gray-100';
